var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"government"},_vm._l((_vm.formData),function(item,index){return _c('van-cell',{key:index,attrs:{"border":false,"title":item.title,"url":item.url,"title-style":_vm.titleStyle,"is-link":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }